import React, { useEffect, useState } from 'react';
import Footer from '../../shared/footer/Footer';
import LoginModal from '../../main/loginModal/LoginModal';
import Head from '../../Global/Head';
import Header from '../../Global/Header';
import { AiOutlineCalendar, AiOutlineShareAlt } from 'react-icons/ai';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { BsBookmark } from 'react-icons/bs';

export default function Blog6() {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(!!accessToken ? false : true);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - increment;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="min-h-screen ">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Head />

      <Header />
      <div className="max-w-7xl mx-auto p-6">
        <h1 className="text-4xl font-bold mt-4">The Psychology of Belonging: Why We Crave Our Tribe</h1>
        <div className="mt-4 flex items-start justify-between">
          <div className="flex items-center gap-4 text-sm text-gray-600">
           
            <div className="flex items-center gap-2">
              <span className="inline-block bg-black text-white px-2 py-0.5 rounded">HighTable</span>
            </div>
          </div>
         
        </div>

        <div className="mt-6 rounded-lg overflow-hidden">
          <img
            src="https://res.cloudinary.com/diecfwnp9/image/upload/v1761551272/WhatsApp_Image_2025-10-27_at_08.38.52_2_prryyf.jpg"
            alt="Where Women Rise Together"
            className="w-full h-64 sm:h-96 object-cover"
          />
        </div>
        <div className="prose max-w-none mt-6">
          <p>
            We live in the most connected era in history, yet loneliness has quietly become a modern epidemic. Scroll through your phone, and you’ll see hundreds of contacts. But how many of them would you really call at 2 AM when life feels heavy? That gap between connection and belonging is exactly what psychology has been trying to explain for decades.
          </p>

          <h3>The Science of Belonging</h3>
          <p>
            Human beings are wired for connection. Psychologists Roy Baumeister and Mark Leary famously called it the “need to belong”—a fundamental drive as important as food and water. When we feel part of a group, our stress lowers, our confidence rises, and even our health improves. Studies show that strong social bonds can extend lifespan as much as quitting smoking or exercising regularly.
          </p>

          <h3>Why We Still Feel Lonely</h3>
          <p>
            If we’re so connected, why do so many of us feel alone? The answer lies in the quality of our connections. A thousand followers or contacts don’t necessarily translate to belonging. What we truly crave are safe spaces where we can show up as ourselves without needing to perform or filter.
          </p>

          <h3>Finding Your Tribe</h3>
          <p>
            Think back to a time when you laughed until your stomach hurt with friends, or when you had a deep, unfiltered conversation that made hours feel like minutes. That’s belonging in action. At Hightable, we aim to make finding your tribe feel natural through shared interests, mentorship, and curated spaces.
          </p>

          <h3>The Ripple Effect of Belonging</h3>
          <p>
            Belonging doesn’t just make us happier—it makes us braver. When people feel supported, they take risks, dream bigger, and show up more authentically. Entire communities thrive when individuals feel safe to be themselves.
          </p>

          <h3>Our Why at Hightable</h3>
          <p>
            We’re not here to add to the noise of digital connection. We’re here to build meaning—spaces that encourage authentic connection, support, and growth.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
